import React from "react";
import {
  BiCaretLeft,
  BiChevronLeft,
  BiLoader,
  BiSupport,
} from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { RiVipCrownFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import svg from "../../assets/images/avatar-person.svg";
import Loading from "../../Components/Loading";
import { useMainContext } from "../../Context";
import { useDashboard } from "./Hooks";
import { MdOutlineVerifiedUser } from "react-icons/md";
const Profile = () => {
  const navigate = useNavigate();
  const {
    state: { user },
  } = useMainContext();
  const profile = [
    { id: 1, title: "تکمیل اطلاعات پروفایل" },
    { id: 2, title: "آگهی های من" },
    { id: 3, title: "پرداخت های من" },
    { id: 4, title: "آگهی های نشان شده" },
    { id: 5, title: "تنظیمات" },
  ];
  const { loading, data } = useDashboard();
  if (loading) {
    return <Loading count={2} />;
  }
  return (
    <div className="container-fluid bg-profile">
      <div className="row">
        <div className="col">
          <div className="profile">
            <div className="hero-profile">
              <div className="d-flex  hero-wrapper align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="profile-img">
                    <img src={user?.user?.photo ? user?.user?.photo[0] : svg} />
                  </div>
                  <div className="profile-info">
                    <p className="text text-center name">
                      {user?.user?.fullname}
                    </p>
                    <p className="text text-center mobile">
                      {user?.user?.mobile}
                    </p>
                  </div>
                </div>
                <div>
                  <button
                    className=""
                    onClick={() => {
                      navigate("/completion");
                    }}
                  >
                    <FiEdit size={"1.2rem"} />
                  </button>
                </div>
              </div>

              <div className="detials-user mt-4">
                {[
                  {
                    label: "آگهی های ثبت شده",
                    icon: <MdOutlineVerifiedUser color="#4BB543" />,
                    count: data.submitedAdsCount,
                  },
                  {
                    label: "آگهی درحال بررسی",

                    icon: <BiLoader color="#ffcc00" />,
                    count: data.inProcessAdsCount,
                  },

                  {
                    label: "تیکت های فعال",
                    icon: <BiSupport color="#0099ff" />,
                    count: data.enableTicketCount,
                  },
                ].map(item => {
                  return (
                    <div className="detail-card">
                      <div className="details-icon">{item.icon}</div>
                      <div className="details-amount">
                        <span>{item.label}</span>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "15px",
                          color: "#0099ff",
                        }}
                      >
                        {item.count}
                      </p>
                    </div>
                  );
                })}
              </div>

              {data.planStatus == "false" && (
                <div className="buy-subscription">
                  <div className="sub-title">
                    <RiVipCrownFill color="#ff6a00" size={"1.4rem"} />
                    <p className="title-sub">خرید اشتراک</p>
                  </div>
                  <p className="desc-sub">
                    {" "}
                    برای خرید اشتراک و دسترسی کامل یه سامانه صنعتبان از لینک زیر
                    اقدام کنید.
                  </p>
                  <div
                    className="link-to-plan"
                    onClick={() => {
                      navigate("/plan");
                    }}
                  >
                    <p className="text">خرید اشتراک</p>
                    <BiChevronLeft size={"1.1rem"} color="rgb(46, 46, 149)" />
                  </div>
                </div>
              )}
            </div>

            <div className="buttons">
              {[
                {
                  label: "تکمیل اطلاعات پروفایل",
                  route: "/completion",
                },
                {
                  label: "آگهی های من",
                  route: "/my-ads",
                },
                {
                  label: "پرداخت های من",
                  route: "/payments",
                },
                {
                  label: "آگهی های نشان شده",
                  route: "/bookmarks",
                },
                {
                  label: "پشتیبانی ",
                  route: "/support",
                },
              ].map(item => {
                return (
                  <div
                    className="menu-item d-flex justify-content-between align-items-center"
                    onClick={() => {
                      navigate(item.route);
                    }}
                  >
                    <p>{item.label}</p>
                    <div>
                      <BiCaretLeft color="#2A365D" size={"1rem"} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
